export default function Footer() {
  return (
    <footer className="mt-20 border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand  */}
          <div>
            <h3 className="text-xl font-semibold text-primary">
              Medigenix Health
            </h3>
            <p className="mt-3 text-muted-foreground text-sm leading-relaxed">
              A modern healthcare platform combining technology, clinical
              expertise, and personalized care to empower better health
              decisions.
            </p>
          </div>

          {/* Services  */}
          {/* <div>
            <h4 className="font-semibold text-foreground">Services</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>General Consultation</li>
              <li>Diagnostics</li>
              <li>Nutrition & Wellness</li>
              <li>Chronic Care Management</li>
            </ul>
          </div> */}

          {/* Company  */}
          {/* <div>
            <h4 className="font-semibold text-foreground">Company</h4>
            <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
              <li>About Us</li>
              <li>Our Vision</li>
              <li>Privacy Policy</li>
              <li>Terms & Conditions</li>
            </ul>
          </div> */}

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-foreground">Contact</h4>
            <p className="mt-3 text-sm text-muted-foreground">
              Email:{" "}
              <span className="text-primary">info@medigenixhealth.com</span>
            </p>
            {/* <p className="text-sm text-muted-foreground mt-1">
              Support: support@medigenixhealth.com
            </p> */}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-border mt-10 pt-6 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Medigenix Health — All rights reserved.
        </div>
      </div>
    </footer>
  );
}
